<div class="container" id="main-container">
  <div class="row">
    <div class="col px-lg-4">
      <app-breadcrumbs [path]="data?.path?.alias" [title]="data?.title"></app-breadcrumbs>
    </div>
  </div>
  <div class="row" *ngIf="data.moderation_state == 'archived'">
    <div class="col px-lg-4">
      <div class="callout danger">
        <div class="callout-inner">
          <div class="callout-title">
            <svg class="icon">
              <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
            </svg>
            <span class="visually-hidden">Note</span>
            <span class="text">Contenuto archiviato</span>
          </div>
          <p>
            <span class="node__archived_text">Contenuto archiviato per fini storici di documentazione.</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-8 px-lg-4 py-lg-2">
      <h1 data-audio="" data-element="service-title">
        {{ data.title }}
      </h1>
      <div class="mt-4 mb-4">
        <div class="chip chip-simple" data-element="service-status">
          <span class="chip-label">{{
            data?.service_status ? "Servizio attivo" : "Servizio non attivo"
            }}</span>
        </div>
      </div>
      <p class="subtitle-small mb-3" *ngIf="data?.service_short_description">
        {{ data?.service_short_description }}
      </p>
      <a data-element="service-description" class="btn btn-primary fw-bold" data-focus-mouse="false"
        [href]="data?.service_access?.link_online" target="_blank"
        [ngClass]="{'disabled': data?.service_status == false}" *ngIf="data?.service_access?.link_online"><span
          class="">{{data.service_access.link_online_cta ? data.service_access.link_online_cta : 'Accedi al servizio '
          }}</span>
        <svg class="icon icon-white icon-xs">
          <use href="/bootstrap-italia/dist/svg/sprites.svg#it-external-link"></use>
        </svg>
      </a>
      <p class="text-paragraph mt-3" *ngIf="data?.service_status == false" [innerHTML]="data?.service_reason?.value">
      </p>
    </div>
    <div class="col-lg-3 offset-lg-1">
      <app-social-share [url]="data?.path?.alias"></app-social-share>
      <app-actions-list [mailObject]="data?.title" [path]="data?.path?.alias"></app-actions-list>
      <div class="mt-4 mb-4" *ngIf="data?.field_objectives?.length > 0">
        <div class="row">
          <span class="mb-2 small"><i>Questo contenuto contribuisce agli obiettivi di sviluppo
              sostenibile:</i></span>
        </div>
        <ul class="d-flex flex-wrap gap-1">
          <li *ngFor="let objective of data?.field_objectives">
            <img [src]="objective?.field_icona?.uri?.url" [title]="objective?.name" [alt]="objective?.name"
              class="icon icon-lg" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid my-3" *ngIf="data?.service_image?.field_media_image">
  <div class="row">
    <figure class="figure px-0 img-full">
      <img [src]="data?.service_image?.field_media_image?.uri?.url" class="figure-img img-fluid"
        [alt]="data?.service_image?.field_media_image?.meta?.alt" />
      <figcaption class="figure-caption text-center pt-3">
        {{ data?.service_image?.field_media_image?.meta?.title }}
        <span *ngIf="data?.service_image?.field_media_licence">
          - {{ data?.service_image?.field_media_licence }}</span>
      </figcaption>
    </figure>
  </div>
</div>
<div class="container">
  <div class="row border-top border-light row-column-border row-column-menu-left">
    <aside class="col-lg-3">
      <div class="cmp-navscroll sticky-top" aria-labelledby="accordion-title-one">
        <nav class="navbar it-navscroll-wrapper navbar-expand-lg" aria-label="INDICE DELLA PAGINA" data-bs-navscroll="">
          <div class="navbar-custom" id="navbarNavProgress">
            <div class="menu-wrapper">
              <div class="link-list-wrapper">
                <div class="accordion">
                  <div class="accordion-item">
                    <span class="accordion-header" id="accordion-title-one">
                      <button class="accordion-button pb-10 px-3" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse-one" aria-expanded="true" aria-controls="collapse-one"
                        data-focus-mouse="false">
                        INDICE DELLA PAGINA
                        <svg class="icon icon-xs right">
                          <use href="bootstrap-italia/dist/svg/sprites.svg#it-expand"></use>
                        </svg>
                      </button>
                    </span>
                    <div class="progress">
                      <div class="progress-bar it-navscroll-progressbar" role="progressbar" aria-valuenow="0"
                        aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div>
                    </div>
                    <div id="collapse-one" class="accordion-collapse collapse show" role="region"
                      aria-labelledby="accordion-title-one">
                      <div class="accordion-body">
                        <ul class="link-list" data-element="page-index">
                          <!-- <li class="nav-item" *ngIf="data?.service_short_description">
                            <a class="nav-link" href="#" (click)="scrollTo('description')">
                              <span class="title-medium">Descrizione</span>
                            </a>
                          </li> -->
                          <li class="nav-item" *ngIf="data?.service_purpose">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('who-needs')">
                              <span class="title-medium">A chi è rivolto</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_description?.value">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('desc')"
                              *ngIf="data?.service_description?.value">
                              <span class="title-medium">Descrizione</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('how-to')">
                              <span class="title-medium">Come fare</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_what_takes?.value">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('needed')">
                              <span class="title-medium">Cosa serve</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_what_get?.value">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('obtain')">
                              <span class="title-medium">Cosa si ottiene</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('deadlines')"
                              *ngIf="data?.service_timing?.value">
                              <span class="title-medium">Tempi e scadenze</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_costs?.value">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('costs')"
                              *ngIf="data?.service_costs?.value">
                              <span class="title-medium">Costi</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_access">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('submit-request')">
                              <span class="title-medium">Accedi al servizio</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_particular_cases?.value">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('p-cases')"
                              *ngIf="data?.service_particular_cases?.value">
                              <span class="title-medium">Casi particolari</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_other_info?.value">
                            <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('other-info')"
                              *ngIf="data?.service_other_info?.value">
                              <span class="title-medium">Ulteriori informazioni</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_conditions.length > 0">
                            <a class="nav-link" href="javascript:void(0);" data-focus-mouse="false"
                              (click)="scrollTo('conditions')">
                              <span class="title-medium">Condizioni di servizio</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngIf="data?.service_contacts.length > 0">
                            <a class="nav-link" href="javascript:void(0);" data-focus-mouse="false"
                              (click)="scrollTo('contatti')">
                              <span class="title-medium">Contatti</span>
                            </a>
                          </li>
                          <li class="nav-item" *ngFor="let link of links">
                            <a class="nav-link" href="javascript:void(0);" data-focus-mouse="false"
                              (click)="scrollTo(link?.url)">
                              <span class="title-medium">{{
                                link?.title
                                }}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </aside>
    <div class="col-lg-9 it-page-sections-container border-light" id="main-content">
      <!-- <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="description"
        *ngIf="data?.service_short_description">
        <h2 class="mb-3">Descrizione</h2>
        <div class="richtext-wrapper lora">
          <p [innerHTML]="data?.service_short_description"></p>
        </div>
      </section> -->
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="who-needs"
        *ngIf="data?.service_purpose">
        <h2 class="mb-3">A chi è rivolto</h2>
        <div class="richtext-wrapper" data-element="service-addressed">
          <p [innerHTML]="data?.service_purpose?.value"></p>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="desc"
        *ngIf="data?.service_description?.value">
        <h2 class="mb-3">Descrizione</h2>
        <div class="richtext-wrapper" data-element="service-addressed">
          <p [innerHTML]="data?.service_description?.value"></p>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="how-to" *ngIf="data?.service_how_to">
        <h2 class="mb-3">Come fare</h2>
        <div class="richtext-wrapper" data-element="service-how-to">
          <p [innerHTML]="data?.service_how_to?.value"></p>
        </div>
      </section>

      <section class="it-page-section anchor-offset richtext-wrapper mb-30 has-bg-grey p-3" id="needed"
        *ngIf="data?.service_what_takes">
        <h2 class="mb-3">Cosa serve</h2>
        <div class="richtext-wrapper" data-element="service-needed">
          <p [innerHTML]="data?.service_what_takes?.value"></p>
        </div>
      </section>

      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="obtain" *ngIf="data?.service_what_get">
        <h2 class="mb-3">Cosa si ottiene</h2>
        <div class="richtext-wrapper" data-element="service-achieved">
          <p [innerHTML]="data?.service_what_get?.value"></p>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="deadlines" *ngIf="data?.service_timing">
        <h2 class="title-xxlarge mb-3">Tempi e scadenze</h2>
        <div class="richtext-wrapper" data-element="service-calendar-text">
          <p [innerHTML]="data?.service_timing?.value"></p>
        </div>
        <div class="cmp-timeline" *ngFor="let timeline of data?.field_timeline">
          <div class="calendar-vertical mb-3" data-element="service-calendar-list">
            <div class="calendar-date">
              <h3 class="calendar-date-day">
                <small class="calendar-date-day__year" *ngIf="timeline?.year">{{
                  timeline?.year
                  }}</small>
                <span class="title-xxlarge-regular d-flex justify-content-center" *ngIf="timeline?.day">{{ timeline?.day
                  }}</span>
                <small class="calendar-date-day__month" *ngIf="timeline?.month">{{ timeline?.month }}</small>
              </h3>
              <div class="calendar-date-description rounded">
                <div class="calendar-date-description-content">
                  <h4 class="h5 mb-0">{{ timeline?.desc }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="costs"
        *ngIf="data?.service_costs?.value">
        <h2 class="mb-3">Costi</h2>
        <div class="richtext-wrapper">
          <p [innerHTML]="data?.service_costs?.value"></p>
        </div>
      </section>

      <section id="submit-request" class="it-page-section anchor-offset richtext-wrapper mb-30 mb-3 has-bg-grey p-4">
        <h2 class="mb-3">Accedi al servizio</h2>
        <div class="mt-3">
          <p *ngIf="data?.service_access?.link_online_description"
            [innerHTML]="data?.service_access?.link_online_description"></p>
        </div>
        <div class="mb-4">
          <a role="button" data-element="service-online-access" target="_blank" title="Accedi al servizio"
            class="btn btn-primary fw-bold mobile-full font-sans-serif" [href]="data?.service_access?.link_online"
            *ngIf="data?.service_access?.link_online"><span> {{data.service_access.link_online_cta ?
              data.service_access.link_online_cta : 'Accedi al servizio ' }}
              <svg class="icon icon-white icon-xs">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-external-link">
                </use>
              </svg></span></a>
        </div>
        <div class="mt-3">
          <p *ngIf="data?.service_access?.link_prenotazione_description"
            [innerHTML]="data?.service_access?.link_prenotazione_description"></p>
        </div>
        <div class="mb-4">
          <a *ngIf="data?.service_access?.link_prenotazione" role="button" data-element="service-booking-access"
            target="_blank" title="Prenota appuntamento"
            class="text-primary btn btn-outline-primary t-primary bg-white mobile-full font-sans-serif"
            [href]="data?.service_access?.link_prenotazione"><span> {{data?.service_access?.link_prenotazione_cta ?
              data?.service_access?.link_prenotazione_cta : 'Prenota appuntamento ' }}</span></a>
        </div>
        <!-- Begin Text field "Descrizione" - id:service-access-0-text ALREADY PRESENT -->
        <!-- ADD new data-element! data-element="service-generic-access"-->
        <div class="mt-3" data-element="service-generic-access">
          <p *ngIf="data?.service_access?.text" [innerHTML]="data?.service_access?.text"></p>
        </div>
        <!-- End Text field "Descrizione" - service-access-0-text ALREADY PRESENT -->
        <!-- Begin Card unità organizzative responsabili -->
        <div class="col-12 col-md-8 col-lg-6 mb-30">
          <div class="card-wrapper rounded h-auto mt-10">
            <div class="card card-teaser card-teaser-info rounded shadow-sm p-3"
              *ngFor="let org_unit of data?.service_responsible">
              <div class="card-body pe-3">
                <p class="card-title text-paragraph-regular-medium-semi mb-3">
                  <a [title]="org_unit.title" class="text-decoration-none" data-element="service-area"
                    [href]="org_unit?.path?.alias">
                    {{ org_unit.title }}
                  </a>
                </p>
                <div class="card-text">
                  <p class="card-text" [innerHTML]="
                      stringSubstr(org_unit?.org_unit_short_description, 0, 255)
                "></p>
                </div>
              </div>
              <div class="avatar size-xl" *ngIf="org_unit?.org_unit_image?.field_media_image">
                <img [src]="org_unit?.org_unit_image?.field_media_image?.uri?.url"
                  [alt]="org_unit?.org_unit_image?.field_media_image?.meta?.alt" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="p-cases"
        *ngIf="data?.service_particular_cases?.value">
        <h2 class="mb-3">Casi particolari</h2>
        <div class="richtext-wrapper">
          <p [innerHTML]="data?.service_particular_cases?.value"></p>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="other-info"
        *ngIf="data?.service_other_info?.value">
        <h2 class="mb-3">Ulteriori informazioni</h2>
        <div class="richtext-wrapper">
          <p [innerHTML]="data?.service_other_info?.value"></p>
        </div>
      </section>
      <section class="it-page-section anchor-offset richtext-wrapper mb-30" id="conditions"
        *ngIf="data?.service_conditions?.length > 0">
        <h2 class="mb-3">Condizioni di servizio</h2>
        <p class="text-paragraph">
          Per conoscere i dettagli di scadenze, requisiti e altre informazioni
          importanti, leggi i termini e le condizioni di servizio.
        </p>
        <div class="cmp-icon-link" *ngFor="let documento of data?.service_conditions">
          <a class="list-item icon-left d-inline-block" [href]="documento?.field_media_file?.uri?.url"
            [title]="documento?.field_media_file?.filename" data-element="service-file">
            <span class="list-item-title-icon-wrapper">
              <svg class="icon icon-primary icon-sm me-1" aria-hidden="true">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-clip"></use>
              </svg>
              <span class="list-item">{{ removeExtension(documento?.field_media_file?.filename) }} -
                ({{ documento?.field_media_file?.filesize | filesize }})</span>
            </span>
          </a>
        </div>
      </section>
      <app-contacts [data]="data?.service_contacts"></app-contacts>
      <div class="col-12 mb-30">
        <div class="row">
          <span class="mb-2 small">Argomenti</span>
        </div>
        <ul class="d-flex flex-wrap gap-2 mt-10 mb-3">
          <li *ngFor="let tag of data?.service_tags">
            <a class="chip chip-simple" [href]="tag?.path?.alias" data-element="service-topic">
              <span class="chip-label">{{ tag.title }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div [innerHTML]="jsonLdScript"></div>